import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import routes from "./routes";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./themes/theme.tsx";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { SnackbarProvider } from "notistack";
const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <SnackbarProvider
          maxSnack={5}
          disableWindowBlurListener
          anchorOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
          style={{
            fontFamily: "sans-serif",
          }}
        >
          <CssBaseline />
          <RouterProvider router={routes} />
        </SnackbarProvider>
      </ThemeProvider>
    </QueryClientProvider>
  </StrictMode>
);
